import Configurator from '@m/config/Configurator';

import isLocalhost from '@m/utils/isLocalhost';

export default function getEnvironment() {
  const { hostname } = window.location;
  if (
    isLocalhost() ||
    hostname.includes('localhost') ||
    hostname.includes('.local') ||
    hostname.includes('192.168')
  ) {
    return 'local';
  }
  if (Configurator.CONFIG_ENV === 'staging' || hostname.includes('-staging.metropolis.io')) {
    return 'staging';
  }
  if (
    Configurator.CONFIG_ENV === 'development' ||
    hostname.includes('-development.metropolis.io') ||
    hostname.includes('-dev.metropolis.io')
  ) {
    return 'development';
  }
  if (hostname.includes('-beta.metropolis.io')) {
    return 'production-beta';
  }
  return 'production';
}
